<form
  data-test="hrnxPXEp"
  [ngrxFormState]="formState"
  *ngIf="currentTab.name === tabsTypes.GENERAL"
>
  <section data-test="spE9ecO5" class="section-sm">
    <div data-test="U0uT8tao" class="modules-container">
      <h2 data-test="0O1DYSSg">Personal Details</h2>
      <div data-test="YYsITjFm" class="block block_shadow p-0">
        <div data-test="fOENFe9w" class="row m-0">
          <div data-test="Qcjn4s_6" class="col-auto pt-30 pb-30 pl-30">
            <div data-test="87Thzr2W" class="file-upload form-group">
              <label data-test="2BFojPfz" class="form-group__label" for="input-1">
                Profile picture
              </label>
              <label data-test="WUHmNG0J" class="input-file active">
                <div data-test="bMGUFkAG" class="input-file__img">
                  <label data-test="SElDLkGS" class="input-file">
                    <input
                      data-test="iaG6IFSl"
                      id="input-1"
                      type="file"
                      (change)="onPicChange($any($event.target)?.files)"
                      #fileInput
                    />
                    <div
                      data-test="k0Jd_QjU"
                      *ngIf="user?.contactPhotoFilename as photo"
                      class="file-upload__logo img-square"
                      [style.backgroundImage]="'url(' + (photo | uploads) + ')'"
                    ></div>
                    <div
                      data-test="iAT29fVL"
                      class="input-file__inner"
                      *ngIf="!user?.contactPhotoFilename"
                    >
                      <span data-test="P7Fa5VAf" class="input-file__icon">
                        <svg
                          data-test="w9YqPLqR"
                          class="icon__icon-upload"
                          width="34px"
                          height="30px"
                        >
                          <use xlink:href="#icon-upload"></use>
                        </svg>
                      </span>
                    </div>
                  </label>
                </div>
                <div data-test="Y2OrUj2U" class="input-file__inner">
                  <span data-test="CQPgPJWm" class="input-file__icon">
                    <svg
                      data-test="LCqJBB5v"
                      class="icon__icon-upload"
                      width="34px"
                      height="30px"
                    >
                      <use xlink:href="#icon-upload"></use>
                    </svg>
                  </span>
                </div>
              </label>
              <button
                data-test="sX_YKGGn"
                (click)="openFileDialog()"
                class="file-upload__button button button_primary button_sm w-100"
                type="button"
              >
                <span data-test="yk7onATM" class="button__icon button__icon_left">
                  <i
                    data-test="236vzVSf"
                    class="material-icons md-14"
                    style="margin: 0 -2px"
                  >
                    file_upload
                  </i>
                </span>
                <span data-test="puxB8DYq">Change Picture</span>
              </button>
            </div>
          </div>
          <div data-test="FRJ2EBou" class="col-4 col-xl pt-30 pb-30 pr-30">
            <div data-test="-ACLXHDt" class="row">
              <div data-test="wJmh7-mk" class="col">
                <div data-test="z0ckOJhJ" class="row gutters-20">
                  <div data-test="GlpoKlZa" class="col">
                    <cc-input-dropdown
                      data-test="aQHEF3Fh"
                      [label]="'Title'"
                      (itemSelected)="selectTitle($event)"
                      [items]="['Mr', 'Mrs', 'Ms']"
                      [currentItem]="formState.controls.title"
                    >
                      <input
                        data-test="IAvQ0qeW"
                        readonly
                        [ngrxFormControlState]="formState.controls.title"
                        class="input dropdown-focus"
                      />
                    </cc-input-dropdown>
                  </div>
                  <div data-test="LuEpSRJX" class="col">
                    <div data-test="ZPWn9VyB" class="form-group">
                      <div data-test="5b6-drW3" class="form-group__label">First Name</div>
                      <div data-test="HOoJ5ffs" class="form-group__field">
                        <input
                          data-test="b4uDC4zE"
                          class="input"
                          [ngrxFormControlState]="formState.controls.firstName"
                        />
                      </div>
                    </div>
                  </div>
                  <div data-test="K1iNBoZU" class="col">
                    <div data-test="Rl_TqsTk" class="form-group">
                      <div data-test="gYtYZQdH" class="form-group__label">Last Name</div>
                      <div data-test="Rox5C2S5" class="form-group__field">
                        <input
                          data-test="d59K7k54"
                          class="input"
                          [ngrxFormControlState]="formState.controls.lastName"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-test="FECxhW0J" class="row">
              <div data-test="ovPn8_0p" class="col">
                <div data-test="Y4H4mHoJ" class="row gutters-20">
                  <div data-test="43Pwa_-T" class="col">
                    <div data-test="XXbcspBo" class="form-group">
                      <div data-test="nmo-TYYm" class="form-group__label">Birth date</div>
                      <div data-test="_rUfcQXn" class="form-group__field">
                        <md-datepicker
                          data-test="xU4Bcl-8"
                          inputClasses=""
                          [ngrxFormControlState]="
                            formState.controls.birthDate | asDateControl
                          "
                          [ngrxValueConverter]="dateValueConverter"
                          [returnNullInCaseInvalidInput]="false"
                        ></md-datepicker>
                      </div>
                    </div>
                  </div>

                  <!--commented according to https://app.clickup.com/t/1t30qd6                  -->
                  <!--                  <div class="col" style="">-->
                  <!--                    <label class="form-group__label">Language</label>-->
                  <!--                    <md-dropdown-->
                  <!--                      inputClasses=""-->
                  <!--                      placeholder="Select language"-->
                  <!--                      id="language"-->
                  <!--                      valueKey="name"-->
                  <!--                      labelKey="name"-->
                  <!--                      [filter]="true"-->
                  <!--                      [options]="languages || []"-->
                  <!--                      [ngrxFormControlState]="formState.controls.language"-->
                  <!--                    ></md-dropdown>-->
                  <!--                  </div>-->

                  <div data-test="b2EfAZdV" class="col">
                    <label data-test="XWDHd1s5" class="form-group__label">Timezone</label>
                    <md-dropdown
                      data-test="GwsxfNRP"
                      inputClasses=""
                      placeholder="Select timezone"
                      id="timezone"
                      valueKey="uuid"
                      labelKey="name"
                      [filter]="true"
                      [options]="timezones || []"
                      [ngrxFormControlState]="formState.controls.timezone"
                    ></md-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div data-test="28jsBx51" class="row">
              <div data-test="Z6-Mr5E7" class="form-group col-12 col-lg-6">
                <label data-test="1QT5Gmta" class="form-group__label">Emails</label>
                <div data-test="qg9aDkc8" class="row gutters-20">
                  <div data-test="98qpJ4KM" class="form-group form-group_sm col-auto">
                    <input
                      data-test="faTJFWvo"
                      placeholder="label"
                      class="input w-110"
                      style="width: 150px"
                      [mdDisableInput]="true"
                      value="Main"
                    />
                  </div>
                  <div
                    data-test="Zn1WpqUv"
                    class="form-group form-group_sm col d-flex align-items-center"
                    [class.error]="isEmailInvalid()"
                  >
                    <div data-test="hnPqtnx0" class="form-group__field flex-grow-1 mr-3">
                      <input
                        data-test="_6y1FDJz"
                        class="input"
                        placeholder="Enter email address"
                        [ngrxFormControlState]="
                          formState.controls.emails.controls[0].controls.email
                        "
                        (keyup)="
                          onMainEmailChange(
                            formState.controls.emails.controls[0].controls.email
                          )
                        "
                      />
                      <div
                        data-test="hONBlPd2"
                        class="input-status"
                        style="top: 50%"
                        *ngIf="isEmailInvalid()"
                        [mdTooltip]="
                          this.formState.controls.emails.controls[0].controls.email.errors
                            .$exists
                            ? ErrorMessages.EmailAlreadyExists
                            : ErrorMessages.IncorrectFormat
                        "
                      >
                        <i
                          data-test="u2e4hLuJ"
                          class="material-icons md-22 input-status__icon-error"
                        >
                          error
                        </i>
                        <i
                          data-test="1MkbvRpt"
                          class="material-icons md-22 input-status__icon-valid"
                        >
                          check_circle
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-test="E-Uvx6fm"
                  *ngFor="
                    let email of formState.controls.emails.controls;
                    let i = index;
                    trackBy: trackControl
                  "
                  class="row gutters-20"
                >
                  <ng-container *ngIf="i > 0">
                    <div data-test="eSPNR7Yb" class="col-12"></div>
                    <div data-test="dxNwXY8R" class="form-group form-group_sm col-auto">
                      <input
                        data-test="uoiIbeJO"
                        placeholder="label"
                        [ngrxFormControlState]="email.controls.label"
                        class="input w-110"
                        style="width: 150px"
                        [mdTooltip]="
                          email.value.label
                            ? null
                            : 'Add some text or leave this field blank'
                        "
                      />
                    </div>
                    <div
                      data-test="ibF8Fc4L"
                      class="form-group form-group_sm col d-flex align-items-center"
                      [class.error]="
                        (email.isInvalid && email.isDirty) ||
                        (email.isInvalid && showValidationError)
                      "
                    >
                      <div
                        data-test="yJnRrzXI"
                        class="form-group__field flex-grow-1 mr-3"
                      >
                        <input
                          data-test="LgMLshJ7"
                          placeholder="Enter email address"
                          [ngrxFormControlState]="email.controls.email"
                          class="input"
                        />
                      </div>
                      <button
                        data-test="7bB5VLoN"
                        (click)="removeEmailInput(i)"
                        type="button"
                        class="button button_red-outline button_square button_square-sm button_rounded-circle"
                      >
                        <i data-test="YHS7UUru" class="material-icons md-14">close</i>
                      </button>
                    </div>
                  </ng-container>
                </div>
                <div data-test="usRNvOg7" class="link no-underline mt-3">
                  <button
                    data-test="FkQuG3fs"
                    (click)="addEmailInput()"
                    class="button button_primary-outline button_square button_square-sm mr-2"
                    type="button"
                  >
                    <i data-test="zkoIFjNX" class="material-icons">add</i>
                  </button>
                  <span
                    data-test="psH1ePD2"
                    class="text-xsmall font-weight-medium"
                    (click)="addEmailInput()"
                  >
                    Add another email
                  </span>
                </div>
              </div>
              <div data-test="IjmszE-r" class="form-group col-12 col-lg-6">
                <label data-test="-i6LTzw8" class="form-group__label">Phones</label>
                <div data-test="LBGMDx0D" class="row gutters-20">
                  <div data-test="n5twJwTU" class="form-group form-group_sm col-auto">
                    <input
                      data-test="raBJxgIk"
                      placeholder="label"
                      class="input w-110"
                      style="width: 150px"
                      [mdDisableInput]="true"
                      value="Main"
                    />
                  </div>
                  <div
                    data-test="40ncmHrB"
                    class="form-group form-group_sm col d-flex align-items-center"
                  >
                    <div data-test="gvxO6zfi" class="form-group__field flex-grow-1 mr-3">
                      <input
                        data-test="23m6D58m"
                        class="input"
                        [ngrxFormControlState]="
                          formState.controls.phones.controls[0].controls.number
                        "
                        (input)="mainPhoneChange()"
                      />
                    </div>
                  </div>
                </div>
                <div
                  data-test="BDJw3YHl"
                  *ngFor="
                    let phone of formState.controls.phones.controls;
                    let i = index;
                    trackBy: trackControl
                  "
                  class="row gutters-20"
                >
                  <ng-container *ngIf="i > 0">
                    <div data-test="vCLn2uZ7" class="col-12"></div>
                    <div data-test="SMthQS1s" class="form-group form-group_sm col-auto">
                      <input
                        data-test="CW835kUq"
                        placeholder="label"
                        [ngrxFormControlState]="phone.controls.label"
                        class="input w-110"
                        style="width: 150px"
                        [mdTooltip]="
                          phone.value.label
                            ? null
                            : 'Add some text or leave this field blank'
                        "
                      />
                    </div>
                    <div
                      data-test="BQcjA-n6"
                      class="form-group form-group_sm col d-flex align-items-center"
                    >
                      <div
                        data-test="Sy01GbSO"
                        class="form-group__field flex-grow-1 mr-3"
                      >
                        <input
                          data-test="Am5Sbjln"
                          [ngrxFormControlState]="phone.controls.number"
                          class="input"
                        />
                      </div>
                      <button
                        data-test="uM5tYPck"
                        (click)="removePhoneInput(i)"
                        class="button button_red-outline button_square button_square-sm button_rounded-circle"
                      >
                        <i data-test="VF6TpY1Y" class="material-icons md-14">close</i>
                      </button>
                    </div>
                  </ng-container>
                </div>
                <div data-test="qWaa4v2d" class="link no-underline mt-3">
                  <button
                    data-test="sSTNJpgw"
                    (click)="addPhoneInput()"
                    class="button button_primary-outline button_square button_square-sm mr-2"
                    type="button"
                  >
                    <i data-test="46lJ34jH" class="material-icons">add</i>
                  </button>
                  <span
                    data-test="h2TP06ZM"
                    class="text-xsmall font-weight-medium"
                    (click)="addPhoneInput()"
                  >
                    Add another phone
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section data-test="44CRfMxz" class="section-sm">
    <div data-test="oA4v-U7I" class="modules-container">
      <div data-test="gzECX7Sx" class="block block_gray modules-container">
        <form data-test="vBh_XYya" class="form">
          <div data-test="eZ6eBEER" class="row gutters-20">
            <div data-test="U3wcw4kB" class="col-auto mr-5">
              <div data-test="Lqupmeff" class="form-group">
                <div data-test="dWXBt_7I" class="form-group__label">Billable rate</div>
                <div data-test="yG5z71Ey" class="form-group__field text-nowrap">
                  <span data-test="bdz-SzPa" class="text-light mr-1" mdCurrency></span>
                  <!--suppress JSCheckFunctionSignatures -->
                  <input
                    data-test="R0S5zGwV"
                    class="input w-auto mr-2"
                    type="text"
                    value="25.00"
                    [size]="4"
                    mask="0*.00"
                    autocomplete="off"
                    *ngIf="formState.controls.billableRate.controls.rate"
                    [ngrxFormControlState]="formState.controls.billableRate.controls.rate"
                    #billableRateInput
                    [dropSpecialCharacters]="false"
                  />
                  <span data-test="bpJie9bD" class="text-light">/ hour</span>
                </div>
              </div>
            </div>
            <div data-test="jasNS2mv" class="col-auto mr-5">
              <div data-test="TWUlKRVB" class="form-group">
                <div data-test="r8GqI6b5" class="form-group__label">Cost</div>
                <div data-test="dY668yXz" class="form-group__field text-nowrap">
                  <span data-test="ORYyVvRQ" class="text-light mr-1" mdCurrency></span>
                  <input
                    data-test="NlmyoYHU"
                    class="input w-auto mr-2"
                    type="text"
                    value="10.00"
                    [size]="4"
                    mask="0*.00"
                    autocomplete="off"
                    [ngrxFormControlState]="formState.controls.costRate"
                    [dropSpecialCharacters]="false"
                  />
                  <span data-test="vEBcIPb0" class="text-light">/ hour</span>
                </div>
              </div>
            </div>
            <div data-test="Cz3uFIrs" class="col-auto mr-5">
              <div data-test="VuE8rg7h" class="form-group">
                <div data-test="DSB4nM0_" class="form-group__label">
                  Capacity per week
                </div>
                <div
                  data-test="I0Vp3KWW"
                  class="form-group__field form-group__field_append"
                >
                  <md-dropdown
                    data-test="lK64l-_6"
                    inputClasses=""
                    [options]="capacityArray"
                    [filter]="true"
                    valueKey="capacity"
                    labelKey="name"
                    [ngrxFormControlState]="formState.controls.capacity"
                  ></md-dropdown>
                </div>
              </div>
            </div>

            <div data-test="EdKUg0EF" class="col-auto mr-5">
              <div data-test="k9AK3Bse" class="form-group">
                <div data-test="8FrzzcmF" class="form-group__label">Occupation Type</div>
                <div
                  data-test="aSwOF6Bm"
                  class="form-group__field form-group__field_append"
                >
                  <md-dropdown
                    data-test="9CIVLSmg"
                    inputClasses=""
                    [multiple]="true"
                    [joinMultipleLables]="true"
                    [url]="listsUrls.OccupationTypes"
                    [getOptionsParams]="{ status: OccupationTypeStatus.ACTIVE }"
                    [filter]="true"
                    [canSelectEmptyOption]="true"
                    [disableCache]="true"
                    emptyOptionLabel="Occupation Type"
                    labelKey="name"
                    compareKey="uuid"
                    [ngrxFormControlState]="$any(formState.controls.occupationTypes)"
                  ></md-dropdown>
                </div>
              </div>
            </div>

            <div data-test="o0EOgllB" class="col-auto mr-5">
              <div data-test="iJFTC_Ib" class="form-group">
                <div data-test="UVxePq62" class="form-group__label">Task Role</div>
                <div
                  data-test="TPXfaKRh"
                  class="form-group__field form-group__field_append"
                >
                  <md-dropdown
                    data-test="9kmyDRl4"
                    inputClasses=""
                    [multiple]="true"
                    [joinMultipleLables]="true"
                    [url]="listsUrls.TaskRoles"
                    [getOptionsParams]="{ status: TaskRoleStatuses.ACTIVE }"
                    [filter]="true"
                    [canSelectEmptyOption]="true"
                    [disableCache]="true"
                    emptyOptionLabel="Task Role"
                    labelKey="name"
                    compareKey="uuid"
                    [ngrxFormControlState]="$any(formState.controls.taskRoles)"
                  ></md-dropdown>
                </div>
              </div>
            </div>

            <div data-test="eGIxW4xE" class="col-auto mr-5 flex-grow-1">
              <div data-test="FTHVLLZ9" class="form-group">
                <div data-test="lZ_YCFV0" class="form-group__label">
                  Social security number
                </div>
                <div data-test="8GxG1IVs" class="form-group__field text-nowrap">
                  <input
                    data-test="shH1WsMJ"
                    class="input mr-2"
                    type="text"
                    value="10.00"
                    [size]="4"
                    autocomplete="off"
                    [ngrxFormControlState]="formState.controls.socialSecurityNumber"
                  />
                </div>
              </div>
            </div>

            <div data-test="8Kv9mSPr" class="col-auto mr-5">
              <div data-test="kDhu8j6Z" class="form-group">
                <div data-test="R4WSO7EJ" class="form-group__label">Fuel code</div>
                <div data-test="qSWBETQK" class="form-group__field text-nowrap">
                  <input
                    data-test="aAMb3gm1"
                    *ngIf="user?.tankCode; else requestTankCodeButton"
                    class="input w-auto mr-2"
                    type="text"
                    [value]="user?.tankCode"
                    disabled
                  />
                  <ng-template #requestTankCodeButton>
                    <button
                      data-test="GZ-FRZLm"
                      (click)="generateFuelCode()"
                      class="button button_primary button_sm w-100"
                      type="button"
                    >
                      <span data-test="ahjDM8ce">Generate fuel code</span>
                    </button>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</form>
<!--suppress JSUnresolvedFunction, JSCheckFunctionSignatures -->
<md-modal
  data-test="6ZEFO__9"
  #billableRateConfirmModal
  confirmBtnText="Save Billable Rate"
  (afterClose)="resetBillableRate($any($event))"
  (confirm)="saveBillableRate(billableRateConfirmModal)"
>
  <md-modal-title data-test="yiIFvnvL">
    <div data-test="fzytBuAQ" class="message-alert message-alert_warning">
      <div data-test="QHQ9xOTO" class="message-alert__text">
        We'll apply your new billable rate to
        <b data-test="wGYx2X9U">
          all projects that use your
          <br data-test="is2gXEeV" />
          default rate.
        </b>
        We won't apply it to projects that use custom rates.
      </div>
    </div>
  </md-modal-title>
  <md-modal-content data-test="2RVJGESn">
    Which time entries would you like the new billable rate applied to?
    <br data-test="gtfiEpuR" />
    <label data-test="QL7nCEwG" class="radio">
      <input
        data-test="1tHy60ZD"
        type="radio"
        [value]="UserBillableRateApplyPeriods.APPLY_FROM_CERTAIN_TIME"
        [ngrxFormControlState]="formState.controls.billableRate.controls.applyPeriod"
      />
      <div data-test="KW5GsIX7" class="radio__label">
        Time entries for yourself from
        <md-datepicker
          data-test="EsG8R7WC"
          class="d-inline-block position-relative"
          inputClasses="d-inline-block input_sm"
          *ngIf="formState.controls.billableRate.controls.applyFrom"
          [ngrxFormControlState]="
            formState.controls.billableRate.controls.applyFrom | asDateControl
          "
          [ngrxValueConverter]="dateValueConverter"
        ></md-datepicker>
        onwards
      </div>
      <span data-test="ziZ4s_E8" class="radio__marker">
        <span data-test="cSDV4Sqb" class="radio__marker-icon"></span>
      </span>
    </label>
    <br data-test="FL8K_NB2" />
    <ui-kit-radio-button
      data-test="htmAs9MM"
      label="All past and future entries for yourself"
    >
      <input
        data-test="fpinrpjz"
        type="radio"
        [value]="UserBillableRateApplyPeriods.APPLY_TO_ALL_TIME"
        [ngrxFormControlState]="formState.controls.billableRate.controls.applyPeriod"
      />
    </ui-kit-radio-button>
  </md-modal-content>
</md-modal>
